import { observer } from 'mobx-react-lite';
import { Container, Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import InvalidResident from '../errors/InvalidResident';

export default observer(function AgreementConfirmation() {
    const {residentStore} = useStore();
    const {confirmedResident} = residentStore;

    if (!confirmedResident) return <InvalidResident />;

    return (
        <Segment inverted textAlign='center' vertical  className='masthead' style={{paddingTop: '40px'}}>
            <Container text>                              
                <>                    
                    <Header as='h3' inverted>
                        Thank you for agreeing to the Village Rules
                    </Header>
                    
                    <Segment style={{overflow: 'auto', height: '80vh', width:'100%' }}> 
                        <Container  textAlign='left' >
                            <h4>
                                <b>Name: {confirmedResident.fullName}</b>
                            </h4>
                            <h4>
                                <b>Mobile: {confirmedResident.mobileNumber}</b>
                            </h4>
                            <h4>
                                <b>Employee/ERMS: {confirmedResident.employeeNumber}</b>
                            </h4>
                            <h4>
                                <b>Village Rules Version: {confirmedResident.ruleVersion}</b>
                            </h4>
                            <h4><b>Signature:</b></h4>       
                                <img src={confirmedResident.signatureBase64} style={{maxWidth:'100%', height:'auto'}} alt='Resident Signature'/>                              
                            <p>
                            An acknowledgement email of your agreement to the BHP Village Rules will be sent to <b>{confirmedResident.email}</b> shortly.
                            </p>
                            <p>
                            You may be asked to present this email when you arrive at the Village by a member of the Village team.
                            </p>
                        </Container>
                    </Segment>                                                                   
                </>                    
            </Container>
        </Segment>
    )
})